import React, { ReactElement, useEffect, useState, useMemo, useCallback, useRef } from "react";
import Toast from "@xpeng/rc-toast";
import {
  wxInit,
  simpleShare,
  shareMiniProgramToWX,
  imgToBase64,
  myInit,
  goToPageV2,
  getParamsFromHash,
  getParamsFromHref
} from "../../utils/common";
import QRCode from "qrcode";
import { trackGdp } from "../../utils/gio-report";
import PopupModelCenter from "../../components/popup-model-center";
import PopupBottomModal from "../../components/popup-bottom-modal";
import { QueryInviterPage, getCurrentUserInfo, getWXMiniQRCode } from "./api";
import { getCurrentUid } from "../../api/web-h5-common";
import LoadingPage from "../../components/loading-page";
import ContactService from "../../components/contact-service";
import MyInvite from "./components/my-invite";
import TabSwitcher from "./components/tab-switcher";
import InviteRanking from "./components/invite-ranking";
import MyReward from "./components/my-reward";
import { generateInvitePoster } from "./utils";
import { generatePosterConfig } from "./utils/poster-config";
import { isMyApp, isWXApp, isXPApp } from "../../utils/constants";

const App = (): ReactElement => {
  // 防止重复请求小程序码
  const isGettingWXMiniQRCode = useRef(false);

  // 获取小程序码URL，仅用于小程序分享/海报
  // 获取小程序码URL，返回url并缓存，避免重复请求
  const getWXMiniQRCodeUrl = async (activityCodeParam?: string) => {
    if (isGettingWXMiniQRCode.current) return;
    isGettingWXMiniQRCode.current = true;
    const code = activityCodeParam || activityCode;
    if (!code) {
      isGettingWXMiniQRCode.current = false;
      return "";
    }
    try {
      const res = await getWXMiniQRCode({
        activityCode: code,
        activityType: 'IR'
      });
      if (res && (res.code === 0 || res.code === 200) && res.data && res.data.qrCodeUrl) {
        setWxQrcodeUrl(res.data.qrCodeUrl);
      } else {
        setWxQrcodeUrl('');
        isGettingWXMiniQRCode.current = false;
        return '';
      }
    } catch (err) {
      setWxQrcodeUrl('');
      isGettingWXMiniQRCode.current = false;
      return '';
    }
    isGettingWXMiniQRCode.current = false;
  };
  const [showQRCode, setShowQRCode] = useState(false); // 显示二维码
  const [qrCode, setQrCode] = useState(""); // 面对面二维码
  const [wxQrcodeUrl, setWxQrcodeUrl] = useState(""); // 小程序码URL
  const isReportedRef = React.useRef<boolean>(false); // 控制首次曝光埋点
  const [showDetailedRule, setShowDetailedRule] = useState(false); // 显示详细规则
  const [inviterPageBackground, setInviterPageBackground] = useState(""); // 邀请页背景
  const [ruleImg, setRuleImg] = useState(""); // 规则图片
  const [inviterPageImg, setInviterPageImg] = useState(""); // 邀请页图片
  const [activityCode, setActivityCode] = useState(""); // 活动code
  const [activityStatus, setActivityStatus] = useState(""); // 活动状态
  const [uid, setUid] = useState(""); // 用户id
  const [isInBlackList, setIsInBlackList] = useState(false); // 是否在黑名单
  const [popupModelVisible, setPopupModelVisible] = useState(false); // 弹窗显示
  const [popupModelData, setPopupModelData] = useState<any>({}); // 弹窗数据

  const [shareCardTitle, setShareCardTitle] = useState(""); // 分享卡片标题
  const [shareCardImg, setShareCardImg] = useState(""); // 分享卡片图片

  const [showGuide, setShowGuide] = useState(false); // 显示指引
  const [pageLoading, setPageLoading] = useState(true); // 页面加载中

  // 新增状态变量对应真实接口返回
  const [isShowRank, setIsShowRank] = useState(false); // 是否展示节点
  const [canShare, setCanShare] = useState(true); // 是否可以分享
  const [sharePoster, setSharePoster] = useState(""); // 分享海报URL
  const [latestCycleInfo, setLatestCycleInfo] = useState<any>(null); // 最新周期信息
  const [successTotal, setSuccessTotal] = useState(0); // 历史邀请成功总数
  const [latestCycleSuccess, setLatestCycleSuccess] = useState(0); // 本期邀请成功数

  const InviteeDetailUrl = `${window.location.origin}/apps/charge-web/invitee-detail.html?activityCode=${activityCode}&inviterUid=${uid}`;

  useEffect(() => {
    wxQrcodeUrl && generateAndSharePoster();
  }, [wxQrcodeUrl]);

  useEffect(() => {
    if (showGuide) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showGuide]);

  // 提醒用户
  const remindUser = () => {
    trackGdp("P20082", "B006", {
      activityId: activityCode,
    });
    console.log("remindUser");
    if (isXPApp) {
      shareMiniProgramToWX({
        shareMainTitle: "一起体验小鹏自营站充电吧",
        shareSubTitle: "一起体验小鹏自营站充电吧",
        shareImgUrl:
          "https://s.xiaopeng.com/xp-charge/mini/common/common-share-icon.png",
        sharePath: `pages/station-list/index`
      });
    } else if (isWXApp) {
      // 拉起微信分享，分享图片给好友
      console.log("拉起微信分享");
      wxInit().then(wx => {
        wx.miniProgram.postMessage({
          data: {
            shareTitle: "一起体验小鹏自营站充电吧",
            shareIcon:
              "https://s.xiaopeng.com/xp-charge/mini/common/common-share-icon.png",
            shareUrl: `pages/station-list/index`
          }
        });
        setShowGuide(true);
      });
    } else {
      const jumpUrl = 'https://static.xiaopeng.com/apps/charge-web/invite-new-guest.html'
      window.location.href = `https://static.xiaopeng.com/apps/charge-web/jump-to-wx-mini.html?page=pages/webpage/index&query=pageUrl%3D${encodeURIComponent(jumpUrl)}`;
    }
  };

  // 黑名单限制
  const showBlackLimitPopup = () => {
    setPopupModelData({
      popupContent: (
        <div className="contentText">您的账号因违规操作被限制，如有疑问请咨询客服</div>
      ),
      rightBtnText: <ContactService><div className="highLight">咨询客服</div></ContactService>,
      close: () => { setPopupModelVisible(false) }
    });
    setPopupModelVisible(true);
  };

  // 不符合邀请条件弹窗
  const showCannotSharePopup = () => {
    setPopupModelData({
      popupContent: (
        <div className="contentText">您暂不符合邀请条件，暂无法邀请</div>
      ),
      leftBtnText: <div className="normal">去查看活动规则</div>,
      leftBtnFun: () => {
        setPopupModelVisible(false);
        setShowDetailedRule(true);
      },
      rightBtnText: <div className="highLight">去充电</div>,
      rightBtnFun: () => {
        setPopupModelVisible(false);
        goToPageV2({ url: 'https://static.xiaopeng.com/apps/charge-web/par-marketing.html#configPage?pageCode=PAGE31234371' });
      },
      close: () => { setPopupModelVisible(false) }
    });
    setPopupModelVisible(true);
  };

  //面对面邀请
  const toInvite = () => {
    trackGdp("P20082", "B003", {
      activityId: activityCode
    });
    if (isInBlackList) {
      showBlackLimitPopup();
      return;
    }
    // 检查是否允许分享
    if (!canShare) {
      showCannotSharePopup();
      return;
    }
    setShowQRCode(true);
  };


  // 生成并分享海报
  const generateAndSharePoster = async () => {
    if (isInBlackList) {
      showBlackLimitPopup();
      return;
    }

    let posterUrl;
    let posterData;
    let posterConfig;

    try {
      const userInfo = await getCurrentUserInfo();

      if (!userInfo || userInfo.code !== 200) {
        Toast.show("获取用户信息失败，请重试");
        return;
      }

      // 生成邀请链接作为二维码URL

      posterData = {
        avatar: userInfo?.data?.headImg || '',
        phoneNumber: userInfo?.data?.mobile || '',
        qrCodeUrl: wxQrcodeUrl,
        bgImageUrl: sharePoster // 传入从接口获取的海报背景图片URL
      };

      // 显示加载提示
      Toast.show("正在生成海报...");

      // 生成海报
      posterUrl = await generateInvitePoster(posterData);

    } catch (error) {
      console.error('海报生成失败:', error);
      Toast.show(`生成海报失败: ${error || '未知错误'}`);
      return;
    }

    // 生成海报配置
    try {
      posterConfig = await generatePosterConfig(posterData);
    } catch (error) {
      console.error('生成海报配置失败:', error);
      Toast.show("生成配置失败，请重试");
      return;
    }

    try {

      // 分享功能
      if (isXPApp) {
        // 在小鹏APP中分享海报
        const imgBase64 = await imgToBase64(posterUrl, 0.8);
        const posterBase64 = imgBase64.split(",")[1] || "";

        simpleShare({
          shareTitle: "邀请有礼",
          shareDesc: "一起体验小鹏自营站充电吧",
          sharePicUrlAccess: posterUrl
        }, window.location.href, posterBase64);
      } else if (isWXApp) {
        // 在微信小程序中使用postMessage传递数据，然后跳转到海报分享页面
        wxInit().then(wx => {
          // 将配置转换为URL参数
          const configStr = encodeURIComponent(JSON.stringify(posterConfig));

          console.log('navigateTo with config:', `/pages/share-poster/index?config=${configStr}`);
          wx.miniProgram.navigateTo({
            url: `/pages/share-poster/index?config=${configStr}`,
            success: function (res) {
              console.log('navigateTo success', res);
            }
          });
        });
      } else {
        // 其他环境的分享逻辑
        const jumpUrl = 'https://static.xiaopeng.com/apps/charge-web/invite-new-guest.html'
        window.location.href = `https://static.xiaopeng.com/apps/charge-web/jump-to-wx-mini.html?page=pages/webpage/index&query=pageUrl%3D${encodeURIComponent(jumpUrl)}`;
      }

    } catch (error) {
      console.error('分享海报失败:', error);
      Toast.show(`分享失败: ${error || '未知错误'}`);
    }
  };

  const BottomBtnRow = () => {
    console.log('BottomBtnRow', isMyApp);
    if (isMyApp) {
      return (
        <div className="btn-row">
          <div className="btn-left" onClick={toInvite}>
            面对面邀请
          </div>
          <div className="btn-gif" onClick={toShare} />
        </div>
      );
    } else {
      return (
        <div className="btn-content">
          <div className="btn-gif" onClick={toShare} />
          <div className="btn-row btn-text">
            <div onClick={toInvite}>
              面对面邀请
            </div>
            <div className="btn-divider"> ｜ </div>
            <div
              onClick={() => {
                trackGdp("P20082", "B017", {
                  activityId: activityCode || '',
                  success_count: sessionStorage.getItem('invite_success_count') || null
                });
                // 检查是否允许分享
                if (!canShare) {
                  showCannotSharePopup();
                  return;
                }
                // 点击时先确保已获取小程序码
                if (!wxQrcodeUrl) {
                  Toast.show("正在生成海报...");
                  getWXMiniQRCodeUrl();
                } else {
                  generateAndSharePoster();
                }
              }}
            >
              生成海报邀请
            </div>
          </div>
        </div>
      );
    }
  };

  const toShare = () => {
    console.log("分享好友");
    trackGdp("P20082", "B004", {
      activityId: activityCode || ''
    });

    // 检查是否允许分享
    if (!canShare) {
      showCannotSharePopup();
      return;
    }

    // 区分环境，支付宝环境的话就展示原来的逻辑
    const url = `pages/webpage/index?pageUrl=${encodeURIComponent(InviteeDetailUrl)}`
    if (isXPApp) {
      shareMiniProgramToWX({
        shareMainTitle: shareCardTitle,
        shareSubTitle: shareCardTitle,
        shareImgUrl: shareCardImg,
        sharePath: url
      });
    } else if (isWXApp) {
      wxInit().then(wx => {
        wx.miniProgram.postMessage({
          data: {
            shareTitle: shareCardTitle,
            shareIcon: shareCardImg,
            shareUrl: `/pages/webpage/index?pageUrl=${encodeURIComponent(InviteeDetailUrl)}`
          }
        });
        setShowGuide(true);
      });
    } else if (isMyApp) {
      myInit().then(my => {
        console.log('myinit', my.miniProgram);
        my.miniProgram.postMessage({
          data: {
            shareTitle: shareCardTitle,
            shareIcon: shareCardImg,
            shareUrl: `/pages/webpage/index?pageUrl=${encodeURIComponent(InviteeDetailUrl)}`
          }
        });
      });
      setShowGuide(true);
    } else {
      // 其他环境的分享逻辑
      const jumpUrl = 'https://static.xiaopeng.com/apps/charge-web/invite-new-guest.html'
      window.location.href = `https://static.xiaopeng.com/apps/charge-web/jump-to-wx-mini.html?page=pages/webpage/index&query=pageUrl%3D${encodeURIComponent(jumpUrl)}`;
    }
  }

  const getAcitivityData = () => {
    QueryInviterPage({
      activityType: "IR"
    })
      .then(res => {
        console.log("QueryInviterPage", res);
        if ([0, 200].includes(res.code)) {
          document.title = res.data.inviterPageTitle || "邀请有礼";

          // 基础活动信息
          setActivityCode(res.data.activityCode);
          setActivityStatus(res.data.activityStatus);
          setShareCardTitle(res.data.shareCardTitle);
          setShareCardImg(res.data.shareCardImg || "");
          setIsInBlackList(res.data.blacklistLimit);

          // 页面配置信息
          setInviterPageBackground(res.data.inviterPageBackground);
          setInviterPageImg(res.data.inviterPageImg || require("./assets/empty-bg.svg"));
          setRuleImg(res.data.ruleImg);

          // 分享相关信息
          setCanShare(res.data.canShare);
          setSharePoster(res.data.sharePoster || ""); // 记录海报背景图片URL

          // 活动功能开关
          setIsShowRank((res.data.hasNode || res.data.openRank) ? true : false);
          if (res.data.hasNode || res.data.openRank) {
            trackGdp("P20082", "B013", {
              activityId: res.data.activityCode
            });
          }

          // 重要：记录统计数据
          setSuccessTotal(res.data.successTotal || 0); // 邀请总数
          setLatestCycleSuccess(res.data.latestCycleSuccess || 0); // 本期邀请人数
          setLatestCycleInfo(res.data.latestCycleInfo); // 最新周期信息

          console.log('统计数据:', {
            successTotal: res.data.successTotal,
            latestCycleSuccess: res.data.latestCycleSuccess,
            latestCycleInfo: res.data.latestCycleInfo,
            sharePoster: res.data.sharePoster
          });
        }
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  // 获取普通二维码（面对面邀请用）
  const getQrCode = () => {
    if (!activityCode || !uid) {
      console.log('activityCode或uid为空，无法生成二维码');
      return;
    }

    QRCode.toDataURL(
      `${window.location.origin}/apps/charge-web/invitee-detail.html?activityCode=${activityCode}&inviterUid=${uid}`,
      function (err, url) {
        console.log(
          "QRCode生成成功",
          `${window.location.origin}/apps/charge-web/invitee-detail.html?activityCode=${activityCode}&inviterUid=${uid}`
        );
        setQrCode(url);
      }
    );

  };

  useEffect(() => {
    getAcitivityData();
    getCurrentUid().then(res => {
      setUid(res);
    });

    // 从 URL 参数中读取 showRule，如果为 1 则自动打开活动规则弹窗
    const showRule = getParamsFromHash('showRule') || getParamsFromHref('showRule');
    if (showRule === '1') {
      setShowDetailedRule(true);
    }
  }, []);

  // 当activityCode和uid都有值时，生成二维码
  useEffect(() => {
    if (activityCode && uid) {
      getQrCode();
    }
  }, [activityCode, uid]);

  // 使用useCallback优化函数引用
  const remindUserCallback = useCallback(() => {
    remindUser();
  }, [activityCode]);

  const switchTabCallback = useCallback((tabIndex: number) => {
    tabIndex === 0 && getAcitivityData();
  }, []);

  // 使用useMemo缓存组件函数，避免每次渲染都创建新的函数
  const myInviteComponent = useMemo(() => {
    const MyInviteComponent = () => (
      <MyInvite
        isShowRank={isShowRank}
        activityCode={activityCode}
        onRemindUser={remindUserCallback}
        successTotal={successTotal}
        latestCycleSuccess={latestCycleSuccess}
        latestCycleInfo={latestCycleInfo}
        isReportedRef={isReportedRef}
      />
    );
    // 为匿名组件添加 displayName 解决ESLint报错
    MyInviteComponent.displayName = 'MyInviteComponent';
    return MyInviteComponent;
  }, [isShowRank, activityCode, remindUserCallback, successTotal, latestCycleSuccess, latestCycleInfo]);

  const inviteRankingComponent = useMemo(() => {
    const InviteRankingComponent = () => (
      <InviteRanking activityCode={activityCode} />
    );
    InviteRankingComponent.displayName = 'InviteRankingComponent';
    return InviteRankingComponent;
  }, [activityCode]);

  const myRewardComponent = useMemo(() => {
    const MyRewardComponent = () => (
      <MyReward />
    );
    MyRewardComponent.displayName = 'MyRewardComponent';
    return MyRewardComponent;
  }, []);

  if (pageLoading) {
    return <LoadingPage />;
  }

  return (
    <div className={`invite-content ${showGuide ? "notScroll" : ""}`}>
      {showGuide && (
        <img
          className="guide-img"
          alt="guide-img"
          src={require("./assets/guide-share-bg.png")}
          onClick={() => {
            setShowGuide(false);
          }}
        />
      )}
      {ruleImg && (
        <div
          className="top-btn"
          onClick={() => {
            trackGdp("P20082", "B002", {
              activityId: activityCode
            });
            setShowDetailedRule(true);
          }}
        >
          活动规则
        </div>
      )}
      {inviterPageImg &&
        (activityStatus !== '1_2' ? (
          <img
            className="top-background"
            src={inviterPageImg}
            alt="top-background"
          />
        ) : (
          <img
            className="empty-background"
            src={require("./assets/empty-bg.svg")}
            alt="empty-background"
          />
        ))}
      <div style={{ backgroundColor: inviterPageBackground ? 'none' : 'rgb(249, 221, 159)' }}>
        {inviterPageBackground && (
          <img
            className="inviter-page-img"
            src={inviterPageBackground}
            alt="inviter-page-img"
          />
        )}
        {/* 只有活动进行中才显示底部按钮 */}
        {activityStatus !== '1_2' && <BottomBtnRow />}
        {!isShowRank ?
          <MyInvite
            isShowRank={isShowRank}
            activityCode={activityCode}
            onRemindUser={remindUser}
            successTotal={successTotal}
            latestCycleSuccess={latestCycleSuccess}
            latestCycleInfo={latestCycleInfo}
            isReportedRef={isReportedRef}
          />
          :
          <TabSwitcher
            MyInviteComponent={myInviteComponent}
            InviteRankingComponent={inviteRankingComponent}
            MyRewardComponent={myRewardComponent}
            switchCallback={switchTabCallback}
            activityCode={activityCode}
          />}

        <div className="bottomImg">
          <img
            className="image"
            alt="img"
            src={require("./assets/bottom-bg-orange.svg")}
          />
        </div>
      </div>

      {showQRCode && (
        <PopupModelCenter
          key='qrCode'
          content={
            <div className="qr-code-content">
              <img
                className="qr-code-image"
                src={qrCode}
                alt=""
              />
              <div
                className="qr-code-close-btn"
                onClick={() => setShowQRCode(false)}
              >
              </div>
            </div>
          }
          zIndex={999}
        />
      )}

      <PopupBottomModal
        visible={showDetailedRule}
        onClose={() => setShowDetailedRule(false)}
        title="详细规则"
      >
        <div className="rule-image">
          <img alt="" src={ruleImg} className="image" />
        </div>
      </PopupBottomModal>
      {popupModelVisible && (
        <PopupModelCenter
          popupTitle={popupModelData?.popupTitle}
          leftBtnText={popupModelData?.leftBtnText}
          rightBtnText={popupModelData?.rightBtnText}
          leftBtnFun={popupModelData?.leftBtnFun}
          rightBtnFun={popupModelData?.rightBtnFun}
          content={popupModelData?.popupContent}
          close={popupModelData?.close}
        />
      )}
    </div>
  );
};

export default App;
